import {FormProvider, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {getBudgetFilterDefaultValues} from "../../real_estate/utils/get_budget_filter_default_values";
import {BudgetFieldsNames, FilterBudget} from "../../search/components/generic_filters/FilterBudget";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

export const BudgetFilterBox = () => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);

    const defaultValues = getBudgetFilterDefaultValues(searchFormValues);

    const formMethods = useForm({
        defaultValues
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    });

    const onSubmit = async (values: typeof defaultValues) => {
        const instalment = values[BudgetFieldsNames.CREDIT];
        const budget = values[BudgetFieldsNames.TOTAL];
        const selectedFilter = values[BudgetFieldsNames.RADIO];

        const newFormValues = {
            ...searchFormValues,
            ...(selectedFilter === "total" ? {price: {lower: "", upper: budget}, instalment: ""} : {price: {lower: "", upper: ""}, instalment: instalment})
        };

        hitGtmFilterBudgetInBox(selectedFilter === "monthly");

        await submitSearchForm(newFormValues);
    };

    return (
        <OfferBoxBase css={boxBase}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} css={formStyle}>
                    <div css={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <FilterBudget inputVariant="column" />

                    <Button css={fullWidth} variant="filled_primary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProvider>
        </OfferBoxBase>
    );
};

const boxBase = css`
    min-height: 450px;
`;

const formStyle = css`
    height: 100%;
    width: 100%;
    ${p(3, 2)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
`;

const fullWidth = css`
    width: 100%;
`;

const headerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(2)};
`;
import {FormProvider, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {getBudgetFilterDefaultValues} from "../../real_estate/utils/get_budget_filter_default_values";
import {BudgetFieldsNames, FilterBudget} from "../../search/components/generic_filters/FilterBudget";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

export const BudgetFilterBox = () => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);

    const defaultValues = getBudgetFilterDefaultValues(searchFormValues);

    const formMethods = useForm({
        defaultValues
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad
    });

    const onSubmit = async (values: typeof defaultValues) => {
        const instalment = values[BudgetFieldsNames.CREDIT];
        const budget = values[BudgetFieldsNames.TOTAL];
        const selectedFilter = values[BudgetFieldsNames.RADIO];

        const newFormValues = {
            ...searchFormValues,
            ...(selectedFilter === "total" ? {price: {lower: "", upper: budget}, instalment: ""} : {price: {lower: "", upper: ""}, instalment: instalment})
        };

        hitGtmFilterBudgetInBox(selectedFilter === "monthly");

        await submitSearchForm(newFormValues);
    };

    return (
        <OfferBoxBase css={boxBase}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} css={formStyle}>
                    <div css={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <FilterBudget inputVariant="column" />

                    <Button css={fullWidth} variant="filled_primary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProvider>
        </OfferBoxBase>
    );
};

const boxBase = css`
    min-height: 450px;
`;

const formStyle = css`
    height: 100%;
    width: 100%;
    ${p(3, 2)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
`;

const fullWidth = css`
    width: 100%;
`;

const headerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${calculateRemSize(2)};
`;
